import React from "react";

const AppPricingAppCount = () => {

    return (
        <>
           43
        </>
    );
};

export default AppPricingAppCount;
